import { availableFeatures, useFeatures } from './use_features'

export function useSearchEnabled() {
  const { featureEnabled } = useFeatures()

  return (
    featureEnabled(availableFeatures.search) || featureEnabled(availableFeatures.search_rollout)
  )
}
